import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import multiplevalidateReCaptcha from "@NA/Handlers/MultipleRecaptcha/ADIValidateReCaptchaHandler";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import addAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import ListItem from "@insite/mobius/Lists/ListItem";
import UnorderedList from "@insite/mobius/Lists/UnorderedList";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Radio, { RadioPresentationProps } from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import getStatesData from "@NA/Handlers/ADIGetStatesRegnForm";
import getTranslationsData from "@NA/Handlers/ADIGetTranslationsForRegnForm";
import ADIColors from "@NA/Utils/ADIColors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import Link from "@insite/mobius/Link";
import submitOnlineRegnForm from "@NA/Handlers/ADIOnlineRegnFormSubmitHandler";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import ReCAPTCHA from "react-google-recaptcha";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import getColor from "@insite/mobius/utilities/getColor";
import LazyImage from "@insite/mobius/LazyImage";
import Hidden from "@insite/mobius/Hidden";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import RewardsTooltipIcon from "@NA/Icons/RewardsTooltipIcon";

const enum fields {
    captchaIds = "captchaIds",
}

interface CustomProps extends WidgetProps {
    fields: {
        [fields.captchaIds]: string;
    };
}

const mapDispatchToProps = {
    addAccount,
    signIn,
    validatePassword,
    //validateReCaptcha: makeHandlerChainAwaitable<any, boolean>(validateReCaptcha),

    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> },
        boolean
    >(validateReCaptcha),
    getStatesData,
    getTranslationsData,
    submitOnlineRegnForm,
};

const mapStateToProps = (state: ApplicationState) => ({
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state),
    languageId: state.context.session.language?.id,
    session: state.context.session,
});

type Props = WidgetProps &
    CustomProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory;

export interface CreateAccountStyles {
    form?: InjectableCss;
    heading?: TypographyPresentationProps;
    headingBorderBottom: InjectableCss;
    requirementsTextWrapper: InjectableCss;
    requirementsText: TypographyPresentationProps;
    requirementsErrorText: TypographyPresentationProps;
    errorMgsText: TypographyPresentationProps;
    fieldsLabel: TypographyPresentationProps;
    fieldsLabelAuth: TypographyPresentationProps;
    fieldsErrorLabel: TypographyPresentationProps;
    textFieldsStyle: TextFieldPresentationProps;
    selectTextFieldsStyle: SelectPresentationProps;
    selectTextFieldsErrorStyle: SelectPresentationProps;
    checkboxError: CheckboxPresentationProps;
    checkboxStyles: CheckboxPresentationProps;
    textFieldsErrorStyle: TextFieldPresentationProps;
    checkBoxDescWrapper: InjectableCss;
    recaptchaGridContainer: GridContainerProps;
    recaptcha: InjectableCss;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    fieldsGridItem?: GridItemProps;
    fieldsGridChildContainer?: GridContainerProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    passwordRequirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordGridContainer?: GridContainerProps;
    fullAccessTxt?: InjectableCss;
    fullAccessTxtAndLimitedTxT?: InjectableCss;
    Ul?: InjectableCss;
    Li?: InjectableCss;
    submitGridContainer?: GridContainerProps;
    dontHaveAccLink?: InjectableCss;
    firstGridItem?: GridItemProps;
    secondGridItem?: GridItemProps;
    suggestionText?: InjectableCss;
    suggestionTextEmail?: InjectableCss;
    parentBecomeacustomer?: InjectableCss;
    TypographyTextSize?: InjectableCss;
    radioOptionStyle?: RadioPresentationProps;
    fullAccessTextStyle?: TypographyPresentationProps;
    accessLevelListContainer?: InjectableCss;
    accessLevelListContainer2?: InjectableCss;
    tooltip?: TooltipPresentationProps;
    rightcontent?: InjectableCss;
}

export const createAccountStyles: CreateAccountStyles = {
    form: {
        css: css`
            background: ${ADIColors.white1};
            border-radius: 5px;
            margin-left: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: 200px;
                        margin-left: 0px;
                        padding: 0px 12px 0px 12px;
                    `,
                    css`
                        min-height: 200px;
                        margin-left: 0px;
                        padding: 0px 12px 0px 12px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    null,
                    css`
                        max-width: 672px;
                    `,
                ])}
        `,
    },
    heading: {
        css: css`
            padding: 10px;
            padding-left: 30px;
            margin-bottom: 0px !important;
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 30px 0px 18px 0px;
                    `,
                    css`
                        padding: 30px 0px 18px 0px;
                    `,
                    css`
                        padding: 20px 12px 0px 12px;
                    `,
                    css`
                        padding: 20px 12px;
                    `,
                    css`
                        padding: 20px 0px 0px 20px;
                    `,
                ])}
        `,
    },
    headingBorderBottom: {
        css: css`
            border-bottom: 2px solid ${ADIColors.gray15};
            width: 94%;
            margin: 0 auto;
            margin-top: 19px;
        `,
    },
    requirementsTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: 1rem;
        `,
    },
    requirementsText: {
        css: css`
            font-size: 14px;
            padding-left: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 5px;
                    `,
                    css`
                        padding-left: 5px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    requirementsErrorText: {
        css: css`
            padding-left: 15px;
            color: ${ADIColors.errorFields};
        `,
    },
    errorMgsText: {
        css: css`
            padding-left: 33px;
            margin: 5px 0px;
            color: ${ADIColors.errorFields};
        `,
    },
    fieldsLabel: {
        css: css`
            width: 100%;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            color: default;
            margin-top: 0px;
            margin-bottom: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                        padding-left: 5px;
                        margin-bottom: 0px !important;
                    `,
                    css`
                        text-align: left;
                        padding-left: 5px;
                        margin-bottom: 0px !important;
                    `,
                    css`
                        font-size: 12px;
                        margin-bottom: 0px;
                    `,
                    null,
                    css`
                        margin-bottom: 0px;
                    `,
                ])}
        `,
    },
    fieldsLabelAuth: {
        css: css`
            width: 100%;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            color: default;
            margin-top: 3px;
            margin-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                        padding-left: 5px;
                        margin-bottom: 0px !important;
                    `,
                    css`
                        text-align: left;
                        padding-left: 5px;
                        margin-bottom: 0px !important;
                    `,
                    css`
                        font-size: 12px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    fieldsErrorLabel: {
        css: css`
            width: 100%;
            text-align: right;
            font-weight: bold;
            font-size: 14px;
            color: ${ADIColors.errorFields};
            margin-top: 3px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                        padding-left: 0px;
                        margin-bottom: 0px !important;
                    `,
                    css`
                        text-align: left;
                        padding-left: 0px;
                        margin-bottom: 0px !important;
                    `,
                    null,
                    null,
                    css`
                        padding-left: 5px;
                    `,
                ])}
        `,
    },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    fieldsGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-direction: column;
            padding: 30px 15px;
        `,
    },
    fieldsGridChildContainer: {
        css: css`
            margin: 0px auto 20px 0px;
            > ${GridOffset} {
                width: 100%;
                margin: auto;
                flex-direction: row;
                > ${GridItemStyle} {
                    padding: 0 15px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 500px;
                        > ${GridOffset} {
                            width: 100%;
                            margin: auto;
                            flex-direction: column;
                            > ${GridItemStyle} {
                                padding: 0px;
                            }
                        }
                    `,
                    css`
                        max-width: 500px;
                        > ${GridOffset} {
                            width: 100%;
                            margin: auto;
                            flex-direction: column;
                            > ${GridItemStyle} {
                                padding: 0px;
                            }
                        }
                    `,
                    css`
                        margin: 0px auto 10px 0px;

                        > ${GridOffset} {
                            flex-direction: column;
                        }
                        > ${GridItemStyle} {
                            padding: 0px 0px 15px 15px;
                        }
                    `,
                    null,
                    css`
                        > ${GridOffset} {
                            > ${GridItemStyle} {
                                &:first-child {
                                    width: 267.5px;
                                    flex-basis: 267.5px;
                                    max-width: 267.5px;
                                    max-height: 44px;
                                    > span {
                                        padding-right: 30px;
                                    }
                                }
                                &:last-child {
                                    width: 287px;
                                    max-width: 287px;
                                    flex-basis: 287px;
                                }
                            }
                        }
                    `,
                ])}
        `,
    },
    subscriptionGridItem: {
        width: 12,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: { width: 12 },
    submitGridItem: {
        width: [12, 12, 7, 7, 8],
        css: css`
            justify-content: left;
            margin: 35px 10px 6rem !important;
            padding: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 35px 10px 30px !important;
                    `,
                    css`
                        margin: 35px 10px 30px !important;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                ])}
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    textFieldsStyle: {
        css: css`
            > ${FormInputWrapper} > input {
                height: 45px;
                width: 288px;
            }
        `,
    },
    textFieldsErrorStyle: {
        css: css`
            border: 2px solid ${ADIColors.errorFields} !important;
            > ${FormInputWrapper} > input {
                height: 45px;
                width: 288px;
            }
        `,
    },
    selectTextFieldsStyle: {
        css: css`
            > ${FormInputWrapper} > input {
                height: 45px;
                width: 288px;
            }
        `,
    },
    selectTextFieldsErrorStyle: {
        css: css`
            border: 2px solid ${ADIColors.errorFields} !important;
            color: ${ADIColors.errorFields} > option {
                color: ${ADIColors.errorFields};
            }
            > ${FormInputWrapper} > input {
                height: 45px;
                width: 288px;
            }
        `,
    },
    checkboxStyles: {
        css: css`
            > ${TypographyStyle} {
                font-weight: bold;
            }
        `,
    },
    checkboxError: {
        css: css`
            > ${TypographyStyle} {
                font-weight: bold;

                color: ${ADIColors.errorFields};
            }
        `,
    },
    checkBoxDescWrapper: {
        css: css`
            padding-left: 25px;
            font-size: 12px;
            a {
                text-decoration: underline;
                text-decoration-color: ${ADIColors.blue5};
            }
        `,
    },
    recaptchaGridContainer: {
        css: css`
            width: 100%;
            > ${GridOffset} {
                display: flex;
                margin: 30px 15px;
                width: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        > ${GridOffset} {
                            justify-content: flex-end;
                            width: auto;
                            margin: 15px;
                        }
                    `,
                    css`
                        > ${GridOffset} {
                            justify-content: flex-end;
                            width: auto;
                            margin: 15px;
                        }
                    `,
                    css`
                        > ${GridOffset} {
                            justify-content: flex-end;
                            width: auto;
                            margin: 15px;
                            > div {
                                position: relative;
                                right: 90px;
                            }
                        }
                    `,
                ])};
        `,
    },
    recaptcha: {
        css: css`
            position: relative;
            left: 70px;
            margin: 30px 0px;
        `,
    },
    dontHaveAccLink: {
        css: css`
            display: flex;
            justify-content: center;
            font-size: 12px;
            margin-bottom: 3rem;
        `,
    },
    firstGridItem: {
        width: [12, 12, 5, 5, 4],
        css: css`
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        align-self: flex-start;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    secondGridItem: {
        width: [12, 12, 5, 5, 4],
        css: css`
            flex-direction: column;
            input[type="text"],
            input[type="email"],
            select,
            input[type="password"],
            input[type="tel"] {
                height: 44px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px 15px;
                        ${FormInputWrapper} {
                            margin-left: 0px;
                        }
                    `,
                    css`
                        padding: 0px 15px;
                        ${FormInputWrapper} {
                            margin-left: 0px;
                        }
                    `,
                    css`
                        max-width: 100%;
                        ${FormInputWrapper} {
                            padding-left: 0px;
                        }
                    `,
                    null,
                    css`
                        ${FormInputWrapper} {
                            width: 100%;
                            margin-top: 0px !important;
                            input[type="text"],
                            input[type="email"],
                            select,
                            input[type="password"],
                            input[type="tel"] {
                                height: 44px !important;
                            }
                        }
                    `,
                ])}
        `,
    },
    suggestionText: {
        css: css`
            font-size: 14px;
            position: relative;
            display: flex;
            width: max-content;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                        top: 5px;
                    `,
                    css`
                        padding-left: 0px;
                        top: 5px;
                    `,
                    css`
                        padding-bottom: 5px;
                        font-size: 14px;
                        margin-top: 10px;
                    `,
                    css`
                        padding-bottom: 5px;
                    `,
                    css`
                        padding-bottom: 0px;
                        padding-top: 5px;
                        margin-bottom: 0px !important;
                    `,
                ])};
        `,
    },
    suggestionTextEmail: {
        css: css`
            font-size: 14px;
            position: relative;
            display: flex;
            width: max-content;
            margin-bottom: 10px;
            margin-left: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                        top: 5px;
                    `,
                    css`
                        padding-left: 0px;
                        top: 5px;
                    `,
                    css`
                        margin-bottom: 0px;
                        padding-bottom: 5px;
                        font-size: 14px;
                        margin-top: 10px;
                    `,
                    css`
                        padding-bottom: 5px;
                    `,
                    css`
                        padding-bottom: 0px;
                        padding-top: 5px;
                        margin-bottom: 0px !important;
                    `,
                ])};
        `,
    },
    parentBecomeacustomer: {
        css: css`
            margin-bottom: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin-bottom: -10px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    TypographyTextSize: {
        css: css`
            font-size: 12px;
        `,
    },
    fullAccessTxt: {
        css: css`
            font-weight: bold;
            margin: 8px 12px 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        margin: 3px 22px 0px;
                    `,
                ])};
            ${TypographyStyle} {
                font-weight: bold;
            }
        `,
    },
    fullAccessTxtAndLimitedTxT: {
        css: css`
            font-weight: bold;
            margin: 8px 12px 8px;
            > input + label::before {
                background: #fff;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                        margin: 0px 8px -8px 0px;
                    `,
                ])};
            ${TypographyStyle} {
                font-weight: bold;
            }
        `,
    },
    Li: {
        css: css`
            line-height: 1rem;
        `,
    },
    Ul: {
        css: css`
            margin: 0.5rem 0;
        `,
    },
    submitButton: {
        css: css`
            width: 100%;
            margin: 0 15px;
            min-width: 180px;
            border-radius: 4px;
            font-weight: bold;
            font-size: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                        min-width: 180px;
                        margin: 0 7px;
                    `,
                    css`
                        width: auto;
                        min-width: 180px;
                        margin: 0 7px;
                    `,
                    css`
                        width: auto;
                        margin: 0px 4px;
                    `,
                    css`
                        width: auto;
                        margin: 0px 4px 0px 75px;
                    `,
                    css`
                        width: auto;
                        margin: 0px 4px 0px 75px;
                    `,
                ])};
        `,
    },
    submitGridContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        > ${GridOffset} {
                            width: 130%;
                            justify-content: flex-start;
                            padding-left: 20px;
                        }
                    `,
                    css`
                        height: 100px;
                        > ${GridOffset} {
                            justify-content: flex-end;
                        }
                    `,
                    css`
                        height: 100px;

                        > ${GridOffset} {
                            justify-content: flex-end;
                        }
                    `,
                ])}
        `,
    },
    rightcontent: {
        css: css`
            display: flex;
            align-items: center;
            height: 100%;
            ul {
                margin-left: 0;
                margin-top: 0;
                margin-bottom: 0;
                li {
                    position: relative;
                    padding-bottom: 10px;
                    line-height: 0;
                    list-style-type: none;
                    &:last-child {
                        ${({ theme }) => {
                            return breakpointMediaQueries(theme, [
                                css`
                                    padding-bottom: 0px;
                                `,
                                css`
                                    padding-bottom: 0px;
                                `,
                                css`
                                    padding-bottom: 0px;
                                `,
                                css`
                                    padding-bottom: 0px;
                                `,
                                css`
                                    padding-bottom: 0px;
                                `,
                            ]);
                        }}
                    }
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        height: 100%;
                        width: 100%;
                        padding: 0;
                        margin: 0;
                        ul {
                            margin-left: 0;
                            margin-top: 0;
                            margin-bottom: 0;
                            width: 100%;
                            li {
                                display: flex;
                                padding-top: 14px;
                                padding-bottom: 14px;

                                line-height: 0;
                                list-style-type: none;

                                ${TypographyStyle} {
                                    font-size: 14px;
                                    font-weight: 600;
                                }
                            }
                        }
                    `,
                    css`
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        height: 100%;
                        width: 100%;

                        padding-right: 5px;
                        ul {
                            margin-left: 0;
                            margin-top: 0;
                            margin-bottom: 0;
                            width: 100%;
                            li {
                                display: flex;
                                padding-top: 14px;
                                padding-bottom: 14px;

                                padding-left: 7px;
                                line-height: 0;
                                list-style-type: none;

                                ${TypographyStyle} {
                                    font-size: 14px;
                                    font-weight: 600;
                                }
                            }
                        }
                    `,
                    css`
                        padding-right: 5px;
                        height: 100%;
                        ul {
                            li {
                                padding-bottom: 12px;
                            }
                        }
                    `,
                    null,
                    null,
                ]);
            }}

            .rd-customlink-list.tooltip-link {
                .rd-linklist-linkitem {
                    font-size: 16px;
                    font-weight: bold;

                    line-height: normal;
                    white-space: nowrap;
                    cursor: pointer;
                    color: ${getColor("primary")};
                    :hover {
                        text-decoration: underline;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 14px;
                            `,
                            css`
                                font-size: 14px;
                            `,
                            css`
                                font-size: 14px;
                            `,
                            null,
                            null,
                        ])}
                }
            }

            .tooltip-link {
                position: relative;
                .tooltip-wrapper {
                    // position: relative;
                    position: absolute;
                    right: -18px;
                    top: -5px;
                    z-index: 98;
                    .tooltip-icon {
                        position: relative !important;
                        display: inline-block;
                        height: 17px;
                        width: 17px;
                        vertical-align: bottom;
                        font-style: normal;
                        vertical-align: middle;
                        padding-bottom: 5px;
                        cursor: pointer;

                        &:after {
                            content: "";
                            position: absolute;
                            left: auto;
                            right: 0px;
                            top: 2px;
                            background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/tool-tip-icon.svg);
                            background-repeat: no-repeat;
                            background-size: 17px 17px;
                            background-position: center;
                            cursor: pointer;
                            height: 17px;
                            width: 17px;
                            ${({ theme }) => {
                                return breakpointMediaQueries(theme, [
                                    css`
                                        top: -2px;
                                    `,
                                    css`
                                        top: -2px;
                                    `,
                                    null,
                                    null,
                                    null,
                                ]);
                            }}
                        }

                        &.tooltip-active {
                            &:after {
                                content: "";
                                position: absolute;
                                // left: auto;
                                left: 0px;
                                // right: -5px;
                                right: 201px;
                                //  top: 20px;
                                // top: -6px;
                                background: url(https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Themes/Images/icons/tool-tip-icon-hover.svg);
                                background-repeat: no-repeat;
                                background-size: 17px 17px;
                                background-position: center;
                                cursor: pointer;
                                height: 17px;
                                width: 17px;
                            }

                            .tooltip-text {
                                display: block;
                                margin: 0;
                                transform: translate(-50.5%, 8px);
                                ${({ theme }) => {
                                    return breakpointMediaQueries(theme, [
                                        css`
                                            margin-top: 2px;
                                            width: 310px;
                                            transform: translate(-50.5%, 0px);
                                        `,
                                        css`
                                            margin-top: 2px;
                                            width: 310px;
                                            transform: translate(-50.5%, 0px);
                                        `,
                                        css`
                                            transform: translate(-58%, 8px);
                                        `,
                                        null,
                                        null,
                                    ]);
                                }}
                            }
                        }

                        .tooltip-text {
                            padding: 10px 15px;
                            margin-top: 8px;
                            border: 1px solid #bbb;
                            width: 440px;

                            border-radius: 5px;
                            // margin-left: -136px
                            top: 22px;
                            bottom: 10px;
                            font-size: 14px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            -webkit-letter-spacing: normal;
                            -moz-letter-spacing: normal;
                            -ms-letter-spacing: normal;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2d2926;
                            display: none;
                            background: #ffffff;
                            position: relative;
                            left: -19px;
                            ${({ theme }) => {
                                return breakpointMediaQueries(theme, [
                                    null,
                                    null,

                                    css`
                                        width: 327px;
                                    `,
                                    null,
                                    null,
                                ]);
                            }}
                            > a {
                                font-size: 14px;
                                font-weight: normal;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: normal;
                                letter-spacing: normal;
                                color: #2d2926 !important;
                                text-decoration: underline !important;

                                &:hover {
                                    font-size: 14px;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: normal;
                                    letter-spacing: normal;
                                    color: #2d2926 !important;
                                }
                            }

                            &:before {
                                top: auto;
                                left: 125px;
                                bottom: -10px;
                                border-right: 10px solid transparent;
                                border-bottom: 10px solid #555;
                                border-left: 10px solid transparent;
                                border-bottom-color: #bbb;
                                transform: rotate(180deg);
                            }
                        }
                    }
                }
            }
            .tooltip-icon .tooltip-text:after {
                content: "";
                position: absolute;
                left: calc(55% - 0px);
                bottom: auto;
                top: -2%;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            left: calc(39% + 55px);
                            bottom: auto;
                            top: -2.7%;
                        `,
                        css`
                            left: calc(39% + 55px);
                            bottom: auto;
                            top: -2.7%;
                        `,

                        css`
                            left: calc(64% + 0px);
                        `,
                        null,
                        null,
                    ]);
                }}
                border: 8px solid #fff;
                box-shadow: -1px 1px 0 0 #bbb;
                border-color: transparent transparent #fff #fff;
                -webkit-transform: rotate(136deg);
                -ms-transform: rotate(136deg);
                transform: rotate(136deg);
            }
            .tooltip-wrapper .tooltip-icon .tooltip-text > a span {
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #2d2926 !important;
                text-decoration: underline !important;
            }

            @media only screen and (max-width: 767px) {
                .rd-customlink-list.tooltip-link .rd-linklist-linkitem {
                    margin-top: 0px;
                }
                .tooltip-wrapper {
                    position: unset !important;
                    left: unset !important;
                }
            }
            @media only screen and (min-width: 768px) and (max-width: 1024px) {
                #myAccountLandingDiv .tooltip-link .tooltip-wrapper .tooltip-icon {
                    margin-left: 2px;
                }
            }
        `,
    },
};

const DescriptionWrapper = getStyledWrapper("div");

const styles = createAccountStyles;
const StyledForm = getStyledWrapper("form");

type FormFieldsError = {
    account: boolean;
    accountSuffix: boolean; // This property is being used in P21
    email: boolean;
    firstName: boolean;
    lastName: boolean;
    jobTitle: boolean;
    accessLevel: boolean;
    // companyName: boolean; // Properties commented in P21 change
    //address: boolean;
    // city: boolean;
    // state: boolean;
    //zipCode: boolean;
    bussinessPhone: boolean;
    termsAndConditions: boolean;
};

// Below types are being used by P21
type FieldErrors = {
    firstName: string;
    lastName: string;
};
const CreateAccount = ({
    history,
    validateReCaptcha,
    languageId,
    getStatesData,
    getTranslationsData,
    submitOnlineRegnForm,
    fields,
    session,
}: Props) => {
    const captchaIds = fields.captchaIds ? fields.captchaIds.split(",") : [];
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const currentState = useSelector((state: CustomApplicationState) => state);
    const cart = getCurrentCartState(currentState);
    const billToState = getBillToState(currentState, cart?.value?.billToId);
    const customerAccount = isAuthenticated ? billToState.value?.customerNumber.split("-")[0] : "";
    const customerAccountSuffix = isAuthenticated ? billToState.value?.customerNumber.split("-")[1] : "";

    const [formFields, setFormFields] = useState({
        account: customerAccount,
        accountSuffix: customerAccountSuffix,
        email: "",
        firstName: "",
        lastName: "",
        jobTitle: "",
        accessLevel: "Full Access",
        // companyName: "", // Properties commented in P21
        // address: "",
        // city: "",
        // state: "",
        // zipCode: "",
        bussinessPhone: "",
        mobilePhone: "",
        newsLetter: false,
        termsAndConditions: false,
    });

    const [formFieldsError, setFormFieldsError] = useState<FormFieldsError>({
        account: false,
        accountSuffix: false, // P21 change
        email: false,
        firstName: false,
        lastName: false,
        jobTitle: false,
        accessLevel: false,
        //companyName: false, // Properties commented in P21
        //address: false,
        // city: false,
        // state: false,
        // zipCode: false,
        bussinessPhone: false,
        termsAndConditions: false,
        // Initialize other fields with their appropriate types
    });

    const [labels, setLabels] = useState({
        state: "Select the State",
        jobTitleFirstOption: "Select",
        jobTitleSecondOption: "President/Owner/CEO",
        jobTitleThirdOption: "Sales",
        jobTitleFourthOption: "Purchasing",
        jobTitleFifthOption: "Accounting",
        jobTitleSixthOption: "Other",
    });

    const [statesData, setStatesData] = useState([]);
    const [countryName, setCountryName] = useState("");
    const [errorDetected, setErrorDetected] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [currentJobTitle, setCurrentJobTitle] = useState("");
    const [isMobile, setIsMobile] = React.useState(false);
    const [isTablet, setIsTablet] = React.useState(false);
    const [showRegisterForm, setShowRegisterForm] = React.useState<boolean>(true);
    const [hideRegistrationLink, setHideRegistrationLink] = React.useState(true);
    const [postalCodeMaxLength, setpostalCodeMaxLength] = React.useState<number>(6);
    // Below properties are being used by P21
    const [fieldErrors, setFieldErrors] = useState<FieldErrors>({ firstName: "", lastName: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitRequested, setIsSubmitRequested] = useState(false);

    React.useEffect(() => {
        if (!window) return;
        const onWindowResize = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true);
                setShowRegisterForm(false);
            } else {
                setIsMobile(false);
                setShowRegisterForm(true);
            }
            if (window.innerWidth <= 800) {
                setIsTablet(false);
            } else {
                setIsTablet(true);
            }
        };
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (languageId) {
            getStatesData({
                languageId,
                expand: "states",
                onSuccess: (result: any) => {
                    const locationsData = result.result?.countries[0];
                    const states = locationsData.states;
                    const country = locationsData.name;
                    setCountryName(country ?? "");
                    setStatesData(states ?? []);
                    const countryAbbreviation = locationsData.abbreviation;
                    if (countryAbbreviation) {
                        switch (countryAbbreviation) {
                            case "CA":
                                setpostalCodeMaxLength(6);
                                break;
                            default:
                                // US,PR
                                setpostalCodeMaxLength(5);
                                break;
                        }
                    }
                },
                onComplete(result) {
                    if (result.apiResult) {
                        this.onSuccess?.(result.apiResult);
                    }
                },
            });
            getTranslationsData({
                languageId,
                onSuccess: (result: any) => {
                    const translationsData = result.result;
                    updateLabels(translationsData);
                },
                onComplete(result) {
                    if (result.apiResult) {
                        this.onSuccess?.(result.apiResult);
                    }
                },
            });
        }
    }, []);

    interface TranslationsDataModel {
        frKeyword: string;
        frTranslatedValue: string;
    }

    function updateLabels(transData: Array<TranslationsDataModel>) {
        transData.forEach(function (ele) {
            if (ele.frKeyword === "SelectState") {
                setLabels(prevFields => ({ ...prevFields, ["state"]: ele.frTranslatedValue }));
            }
            if (ele.frKeyword == "SelectJobTitle") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleFirstOption"]: "Select" }));
            }
            if (ele.frKeyword == "PresidentOwnerCEO") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleSecondOption"]: ele.frTranslatedValue }));
            }
            if (ele.frKeyword == "Sales") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleThirdOption"]: ele.frTranslatedValue }));
            }
            if (ele.frKeyword == "Purchasing") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleFourthOption"]: ele.frTranslatedValue }));
            }
            if (ele.frKeyword == "Accounting") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleFifthOption"]: ele.frTranslatedValue }));
            }
            if (ele.frKeyword == "Other") {
                setLabels(prevFields => ({ ...prevFields, ["jobTitleSixthOption"]: ele.frTranslatedValue }));
            }
        });
    }

    const handleChange = (e: (EventTarget & HTMLInputElement) | HTMLSelectElement) => {
        const { name, value } = e;
        if (name === "jobTitle" && value === "") {
            setCurrentJobTitle("");
        } else if (name === "jobTitle" && value === "President/Owner/CEO") {
            setCurrentJobTitle(value);
            setFormFields(prevFields => ({ ...prevFields, ["accessLevel"]: "Full Access" }));
        } else if (name === "jobTitle" && value) {
            setCurrentJobTitle(value);
        }
        setFormFields(prevFields => ({ ...prevFields, [name]: value }));
    };

    const handleAccessLevelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormFields(prevFields => ({ ...prevFields, [name]: value }));
    };

    const handleSignInNewsLetter = (e: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setFormFields(prevFields => ({ ...prevFields, ["newsLetter"]: value }));
    };

    const handleTermsAndConditionsChange = (e: React.SyntheticEvent<Element, Event>, value: boolean) => {
        setFormFields(prevFields => ({ ...prevFields, ["termsAndConditions"]: value }));
    };

    function RegistrationSuccess() {
        history.push("/SignUpConfirm");
    }

    // This function is being used by P21
    const fieldValidator = (fieldName: "firstName" | "lastName", value: string): boolean => {
        const errorFieldName = fieldName === "firstName" ? "First Name" : "Last Name";
        const nameRegexPattern = /^[a-zA-Z ]*$/;

        if (!nameRegexPattern.test(value)) {
            setFormFieldsError(fieldError => ({ ...fieldError, [fieldName]: true }));
            setFieldErrors(prevError => ({
                ...prevError,
                [fieldName]: translate(`Only characters are allowed for ${errorFieldName}`),
            }));
            return false;
        } else {
            if (value !== "") {
                setFieldErrors(prevError => ({ ...prevError, [fieldName]: "" }));
                return true;
            }
        }
        return true;
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        setIsSubmitRequested(true); // P21 Change
        event.preventDefault();
        let emptyFieldsDetected = false;
        let validationErrorsDetected = false;

        Object.keys(formFields).forEach(field => {
            if (field === "newsLetter" || field === "mobilePhone" || field === "accountSuffix") return;

            const fieldValue = formFields[field as keyof typeof formFields];
            if (fieldValue === "") {
                setFormFieldsError(fieldError => ({ ...fieldError, [field]: true }));
                emptyFieldsDetected = true;
            } else {
                setFormFieldsError(fieldError => ({ ...fieldError, [field]: false }));
            }

            if ((field === "firstName" || field === "lastName") && typeof fieldValue === "string") {
                // This condition is being used by P21
                const isValid = fieldValidator(field, fieldValue);
                if (!isValid) {
                    validationErrorsDetected = true;
                }
            }
        });

        if (!formFields["termsAndConditions"]) {
            setFormFieldsError(fieldError => ({ ...fieldError, ["termsAndConditions"]: true }));
            emptyFieldsDetected = true;
        } else {
            setFormFieldsError(fieldError => ({ ...fieldError, ["termsAndConditions"]: false }));
        }

        var emailRegexPattern =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (formFields.email.trim() && !emailRegexPattern.test(formFields.email)) {
            setFormFieldsError(fieldError => ({ ...fieldError, ["email"]: true }));

            var hostname = window.location.hostname.toString();
            const isfr = hostname.indexOf("fr") > 0;
            if (isfr) {
                setErrorMessage("Veuillez saisir une adresse électronique valide.");
            } else {
                setErrorMessage("Please enter a valid Email address.");
            }
            return;
        } else {
            setErrorMessage("");
        }

        setErrorDetected(emptyFieldsDetected || validationErrorsDetected);

        if (emptyFieldsDetected || validationErrorsDetected) return;

        //const isReCaptchaValid = await validateReCaptcha({ captchaIds });

        const isReCaptchaValid = await validateReCaptcha({
            location: "ForgotPassword",
            recaptchaRef,
        });

        if (!isReCaptchaValid) {
            setErrorDetected(true);
            setErrorMessage("The captcha input is missing.");
            return;
        } else {
            setErrorDetected(false);
            setErrorMessage("");
        }

        setIsLoading(true); // P21 Change

        submitOnlineRegnForm({
            Account: formFields.account == undefined ? "" : formFields.account,
            AccountSuffix: formFields.accountSuffix == undefined ? "" : formFields.accountSuffix,
            Email: formFields.email,
            FirstName: formFields.firstName,
            LastName: formFields.lastName,
            JobTitle: formFields.jobTitle,
            Role: formFields.accessLevel,
            // CompanyName: formFields.companyName, // Code commented by P21
            // Address: formFields.address,
            // City: formFields.city,
            // State: formFields.state,
            //  Country: countryName,
            // Pincode: formFields.zipCode,
            BusinessPhone: formFields.bussinessPhone,
            MobilePhone: formFields.mobilePhone,
            NewsletterSubscription: `${formFields.newsLetter}`,
            Terms: `${formFields.termsAndConditions ? "on" : "off"}`,
            onComplete(result) {
                const res = result.apiResult;
                setIsSubmitRequested(false); // P21 Change
                setIsLoading(false); // P21 Change
                if (res?.emailSent) {
                    setErrorDetected(false);
                    setErrorMessage("");
                    RegistrationSuccess();
                } else if (res?.message) {
                    setErrorDetected(true);
                    setErrorMessage(res.message);
                }
            },
        });
    };

    const handleRegisterNow = () => {
        setShowRegisterForm(true);
        setHideRegistrationLink(false);
    };

    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();
    const [ishover, setishover] = useState(false);

    const tooltipUpdate = () => {
        setishover(true);
    };

    const tooltipDisable = () => {
        setishover(false);
    };

    interface RightContentProps {
        children?: React.ReactNode;
    }
    const RightContent: FC<RightContentProps> = ({ children }) => {
        return (
            <StyledWrapper {...styles.rightcontent}>
                <ul>{children}</ul>
            </StyledWrapper>
        );
    };

    return (
        // Below loadingoverlay is added by P21
        <LoadingOverlay loading={isLoading} spinnerProps={{ color: "primary" }}>
            <StyledForm {...styles.form} onSubmit={submitHandler} noValidate>
                <Typography {...styles.heading} variant="h3">
                    {isAuthenticated ? translate("Add a New User") : translate("Online Account Registration")}
                </Typography>
                <Hidden below="lg">
                    {!isAuthenticated && (
                        <Typography {...styles.requirementsText}>
                            {translate(
                                "Already have an ADI account in the branch? Connect your account number to our website.",
                            )}
                        </Typography>
                    )}
                </Hidden>
                {isMobile && hideRegistrationLink && (
                    <>
                        <Typography {...styles.dontHaveAccLink}>
                            {translate("Don't have an Online Account? ")}&nbsp;
                            <Link onClick={handleRegisterNow}>{translate("Register Now.")}</Link>
                        </Typography>
                        <StyledWrapper {...styles.headingBorderBottom} />
                    </>
                )}
                {showRegisterForm && (
                    <>
                        <Hidden below="lg">
                            <StyledWrapper {...styles.headingBorderBottom}></StyledWrapper>
                        </Hidden>
                        <StyledWrapper {...styles.requirementsTextWrapper}>
                            <Typography {...(errorDetected ? styles.requirementsErrorText : styles.requirementsText)}>
                                {isMobile
                                    ? translate("*Please enter information in required fields")
                                    : translate("Please enter information in required fields*")}
                            </Typography>
                            {errorMessage && <Typography {...styles.errorMgsText}>{errorMessage}</Typography>}
                            {Object.values(fieldErrors).map(err => {
                                // Added in P21
                                if (err === "") {
                                    return;
                                }
                                return (
                                    <Typography {...styles.errorMgsText}>
                                        {err}
                                        <br />
                                    </Typography>
                                );
                            })}
                        </StyledWrapper>
                        <GridContainer style={{ marginBottom: "80px" }}>
                            <GridItem width={12} {...styles.fieldsGridItem}>
                                <GridContainer {...styles.fieldsGridChildContainer}>
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography
                                            {...(formFieldsError.account
                                                ? styles.fieldsErrorLabel
                                                : styles.fieldsLabel)}
                                        >
                                            {translate("Account Number *")}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem} style={{ marginTop: "0px" }}>
                                        <TextField
                                            name="account"
                                            maxLength={10} //  Changed from 10 to 5 by comparing with Spire Prod
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.account}
                                            required
                                            {...(formFieldsError.account
                                                ? styles.textFieldsErrorStyle
                                                : styles.textFieldsStyle)}
                                        />
                                        {!isAuthenticated && (
                                            <StyledWrapper {...styles.parentBecomeacustomer}>
                                                <RightContent>
                                                    <Typography as="li" className="rd-customlink-list tooltip-link">
                                                        <Typography
                                                            as="span"
                                                            {...styles.suggestionText}
                                                            style={{ paddingTop: "5px" }}
                                                        >
                                                            {translate("How to find my account number")}&nbsp;
                                                        </Typography>
                                                        <Typography as="span" className="tooltip-wrapper">
                                                            <Typography
                                                                as="i"
                                                                onMouseEnter={tooltipUpdate}
                                                                onMouseLeave={tooltipDisable}
                                                                className={
                                                                    ishover
                                                                        ? "tooltip-icon tooltip-active"
                                                                        : "tooltip-icon"
                                                                }
                                                            >
                                                                <StyledWrapper className="tooltip-text">
                                                                    <LazyImage
                                                                        src="/UserFiles/US/userfiles/Images/online-registration.png"
                                                                        altText={"shortDecription"}
                                                                    />
                                                                    <Typography style={{ marginTop: 10 }}>
                                                                        {translate(
                                                                            "Your account number appears at the top of your email invoice. The numbers before the dash are the account number and the numbers after the dash are the Suffix/Ship To.",
                                                                        )}
                                                                    </Typography>
                                                                </StyledWrapper>
                                                            </Typography>
                                                        </Typography>
                                                    </Typography>
                                                </RightContent>
                                                <Typography {...styles.suggestionText}>
                                                    {translate("Don't have an account?")}&nbsp;
                                                    <Link href="/Accounts/BecomeACustomer">
                                                        {translate("Become a customer.")}
                                                    </Link>
                                                </Typography>
                                            </StyledWrapper>
                                        )}
                                    </GridItem>
                                </GridContainer>
                                <GridContainer {...styles.fieldsGridChildContainer}>
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography {...styles.fieldsLabel}>{translate("Account Suffix *")}</Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem}>
                                        <TextField
                                            {...styles.textFieldsStyle}
                                            name="accountSuffix"
                                            maxLength={10} // In Spire prod only 3 has been mentioned.
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.accountSuffix}
                                            required
                                            {...(formFieldsError.accountSuffix // Added in P21
                                                ? styles.textFieldsErrorStyle
                                                : styles.textFieldsStyle)}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer
                                    {...styles.fieldsGridChildContainer}
                                    style={{ marginBottom: isMobile ? "0px" : "8px" }}
                                >
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography
                                            {...(formFieldsError.email ? styles.fieldsErrorLabel : styles.fieldsLabel)}
                                        >
                                            {translate("Email Address *")}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem}>
                                        <TextField
                                            {...styles.textFieldsStyle}
                                            name="email"
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.email}
                                            data-test-selector="createAccount_email"
                                            required
                                            placeholder={isAuthenticated ? "Email Address" : ""}
                                            maxLength={50}
                                            {...(formFieldsError.email
                                                ? styles.textFieldsErrorStyle
                                                : styles.textFieldsStyle)}
                                        />
                                        <Typography {...styles.suggestionTextEmail}>
                                            {translate("This will become your username.")}
                                        </Typography>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer {...styles.fieldsGridChildContainer}>
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography
                                            {...(formFieldsError.firstName
                                                ? styles.fieldsErrorLabel
                                                : styles.fieldsLabel)}
                                        >
                                            {translate("First Name *")}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem}>
                                        <TextField
                                            {...styles.textFieldsStyle}
                                            name="firstName"
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.firstName}
                                            required
                                            maxLength={15}
                                            {...(formFieldsError.firstName
                                                ? styles.textFieldsErrorStyle
                                                : styles.textFieldsStyle)}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer {...styles.fieldsGridChildContainer}>
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography
                                            {...(formFieldsError.lastName
                                                ? styles.fieldsErrorLabel
                                                : styles.fieldsLabel)}
                                        >
                                            {translate("Last Name *")}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem}>
                                        <TextField
                                            {...styles.textFieldsStyle}
                                            name="lastName"
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.lastName}
                                            required
                                            maxLength={20}
                                            {...(formFieldsError.lastName
                                                ? styles.textFieldsErrorStyle
                                                : styles.textFieldsStyle)}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer {...styles.fieldsGridChildContainer}>
                                    <GridItem {...styles.firstGridItem}>
                                        <Typography
                                            {...(formFieldsError.jobTitle
                                                ? styles.fieldsErrorLabel
                                                : styles.fieldsLabel)}
                                        >
                                            {translate("Job Title *")}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.secondGridItem}>
                                        <Select
                                            name="jobTitle"
                                            onChange={e => handleChange(e.currentTarget)}
                                            value={formFields.jobTitle}
                                            required
                                            {...(formFieldsError.jobTitle
                                                ? styles.selectTextFieldsErrorStyle
                                                : styles.selectTextFieldsStyle)}
                                        >
                                            <option value="">{translate(labels.jobTitleFirstOption)}</option>
                                            <option value="President/Owner/CEO">
                                                {translate(labels.jobTitleSecondOption)}
                                            </option>
                                            <option value="Sales">{translate(labels.jobTitleThirdOption)}</option>
                                            <option value="Purchasing">{labels.jobTitleFourthOption}</option>
                                            <option value="Accounting">{labels.jobTitleFifthOption}</option>
                                            <option value="Other">{labels.jobTitleSixthOption}</option>
                                        </Select>
                                    </GridItem>
                                </GridContainer>
                                {currentJobTitle !== "" ? (
                                    <>
                                        <GridContainer {...styles.fieldsGridChildContainer}>
                                            <GridItem {...styles.firstGridItem}>
                                                <Typography {...styles.fieldsLabel}>
                                                    {translate("Access Level")}
                                                </Typography>
                                            </GridItem>
                                            <GridItem {...styles.secondGridItem}>
                                                {currentJobTitle === "President/Owner/CEO" ? (
                                                    <>
                                                        <StyledWrapper {...styles.fullAccessTxt}>
                                                            {translate("Full Access")}
                                                        </StyledWrapper>
                                                        <DescriptionWrapper>
                                                            <UnorderedList {...styles.Ul}>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate(
                                                                            "Shop Products, Check Availability & Get Pricing",
                                                                        )}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Create Lists for Future Use")}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Place Orders!")}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Access Order History")}
                                                                    </Typography>
                                                                </ListItem>
                                                            </UnorderedList>
                                                        </DescriptionWrapper>
                                                    </>
                                                ) : (
                                                    <RadioGroup
                                                        name="accessLevel"
                                                        value={formFields.accessLevel}
                                                        onChangeHandler={handleAccessLevelChange}
                                                        error={formFieldsError.accessLevel}
                                                    >
                                                        <Radio
                                                            value="Full Access"
                                                            {...styles.fullAccessTxtAndLimitedTxT}
                                                        >
                                                            {translate("Full Access")}
                                                        </Radio>
                                                        <DescriptionWrapper
                                                            style={{ marginBottom: "10px", marginLeft: "-10px" }}
                                                        >
                                                            <UnorderedList {...styles.Ul}>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate(
                                                                            "Shop Products, Check Availability & Get Pricing",
                                                                        )}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Create Lists for Future Use")}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Place Orders!")}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Access Order History")}
                                                                    </Typography>
                                                                </ListItem>
                                                            </UnorderedList>
                                                        </DescriptionWrapper>
                                                        <Radio
                                                            value="Limited Access"
                                                            {...styles.fullAccessTxtAndLimitedTxT}
                                                        >
                                                            {translate("Limited Access")}
                                                        </Radio>
                                                        <DescriptionWrapper
                                                            style={{ marginBottom: "10px", marginLeft: "-10px" }}
                                                        >
                                                            <UnorderedList {...styles.Ul}>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate(
                                                                            "Shop Products, Check Availability & Get Pricing",
                                                                        )}
                                                                    </Typography>
                                                                </ListItem>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate("Access Order History")}
                                                                    </Typography>
                                                                </ListItem>
                                                            </UnorderedList>
                                                        </DescriptionWrapper>
                                                        <Radio
                                                            value="Access to Product Information"
                                                            {...styles.fullAccessTxtAndLimitedTxT}
                                                        >
                                                            {translate("Access to Product Information")}
                                                        </Radio>
                                                        <DescriptionWrapper style={{ marginLeft: "-10px" }}>
                                                            <UnorderedList {...styles.Ul}>
                                                                <ListItem {...styles.Li}>
                                                                    <Typography {...styles.TypographyTextSize}>
                                                                        {translate(
                                                                            "Shop Products, Check Availability & Get Pricing",
                                                                        )}
                                                                    </Typography>
                                                                </ListItem>
                                                            </UnorderedList>
                                                        </DescriptionWrapper>
                                                    </RadioGroup>
                                                )}
                                            </GridItem>
                                        </GridContainer>
                                        {/* Commented by P21  */}
                                        {/* <GridContainer {...styles.fieldsGridChildContainer}>
                                        <GridItem {...styles.firstGridItem}>
                                            <Typography
                                                {...(formFieldsError.companyName
                                                    ? styles.fieldsErrorLabel
                                                    : styles.fieldsLabel)}
                                            >
                                                {translate("Company Name *")}
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.secondGridItem}>
                                            <TextField
                                                {...styles.textFieldsStyle}
                                                name="companyName"
                                                onChange={e => handleChange(e.currentTarget)}
                                                value={formFields.companyName}
                                                maxLength={30}
                                                required
                                                {...(formFieldsError.companyName
                                                    ? styles.textFieldsErrorStyle
                                                    : styles.textFieldsStyle)}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer {...styles.fieldsGridChildContainer}>
                                        <GridItem {...styles.firstGridItem}>
                                            <Typography
                                                {...(formFieldsError.address
                                                    ? styles.fieldsErrorLabel
                                                    : styles.fieldsLabel)}
                                            >
                                                {translate("Address *")}
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.secondGridItem}>
                                            <TextField
                                                name="address"
                                                {...styles.textFieldsStyle}
                                                onChange={e => handleChange(e.currentTarget)}
                                                value={formFields.address}
                                                required
                                                maxLength={30}
                                                {...(formFieldsError.address
                                                    ? styles.textFieldsErrorStyle
                                                    : styles.textFieldsStyle)}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer {...styles.fieldsGridChildContainer}>
                                        <GridItem {...styles.firstGridItem}>
                                            <Typography
                                                {...(formFieldsError.city
                                                    ? styles.fieldsErrorLabel
                                                    : styles.fieldsLabel)}
                                            >
                                                {translate("City *")}
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.secondGridItem}>
                                            <TextField
                                                name="city"
                                                {...styles.textFieldsStyle}
                                                onChange={e => handleChange(e.currentTarget)}
                                                value={formFields.city}
                                                required
                                                maxLength={20}
                                                {...(formFieldsError.city
                                                    ? styles.textFieldsErrorStyle
                                                    : styles.textFieldsStyle)}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer {...styles.fieldsGridChildContainer}>
                                        <GridItem {...styles.firstGridItem}>
                                            <Typography
                                                {...(formFieldsError.state
                                                    ? styles.fieldsErrorLabel
                                                    : styles.fieldsLabel)}
                                            >
                                                {translate("State *")}
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.secondGridItem}>
                                            <Select
                                                name="state"
                                                onChange={e => handleChange(e.currentTarget)}
                                                value={formFields.state}
                                                required
                                                {...(formFieldsError.state
                                                    ? styles.selectTextFieldsErrorStyle
                                                    : styles.selectTextFieldsStyle)}
                                            >
                                                <option value="">{translate(labels.state)}</option>
                                                {statesData?.map((state: { name: string; value: string }) => (
                                                    <option value={state?.name}>{state?.name}</option>
                                                ))}
                                            </Select>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer {...styles.fieldsGridChildContainer}>
                                        <GridItem {...styles.firstGridItem}>
                                            <Typography
                                                {...(formFieldsError.zipCode
                                                    ? styles.fieldsErrorLabel
                                                    : styles.fieldsLabel)}
                                            >
                                                {translate("Zip Code *")}
                                            </Typography>
                                        </GridItem>
                                        <GridItem {...styles.secondGridItem}>
                                            <TextField
                                                {...styles.textFieldsStyle}
                                                name="zipCode"
                                                onChange={e => handleChange(e.currentTarget)}
                                                value={formFields.zipCode}
                                                required
                                                maxLength={postalCodeMaxLength}
                                                {...(formFieldsError.zipCode
                                                    ? styles.textFieldsErrorStyle
                                                    : styles.textFieldsStyle)}
                                            />
                                        </GridItem>
                                    </GridContainer> */}
                                        <GridContainer {...styles.fieldsGridChildContainer}>
                                            <GridItem {...styles.firstGridItem}>
                                                <Typography
                                                    {...(formFieldsError.bussinessPhone
                                                        ? styles.fieldsErrorLabel
                                                        : styles.fieldsLabel)}
                                                >
                                                    {translate("Business Phone *")}
                                                </Typography>
                                            </GridItem>
                                            <GridItem {...styles.secondGridItem}>
                                                <TextField
                                                    name="bussinessPhone"
                                                    onChange={e => handleChange(e.currentTarget)}
                                                    value={formFields.bussinessPhone}
                                                    required
                                                    maxLength={10}
                                                    {...(formFieldsError.bussinessPhone
                                                        ? styles.textFieldsErrorStyle
                                                        : styles.textFieldsStyle)}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.fieldsGridChildContainer}>
                                            <GridItem {...styles.firstGridItem}>
                                                <Typography {...styles.fieldsLabel}>
                                                    {translate("Mobile Phone")}
                                                </Typography>
                                            </GridItem>
                                            <GridItem {...styles.secondGridItem}>
                                                <TextField
                                                    {...styles.textFieldsStyle}
                                                    name="mobilePhone"
                                                    maxLength={10}
                                                    onChange={e => handleChange(e.currentTarget)}
                                                    value={formFields.mobilePhone}
                                                    required
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.fieldsGridChildContainer}>
                                            <GridItem {...styles.firstGridItem}></GridItem>
                                            <GridItem {...styles.secondGridItem}>
                                                <CheckboxGroup>
                                                    <Checkbox
                                                        aria-describedby="setDefaultCustomer-description"
                                                        checked={formFields.newsLetter}
                                                        onChange={handleSignInNewsLetter}
                                                        {...styles.checkboxStyles}
                                                    >
                                                        {translate("Sign Me Up for ADI Emails")}
                                                    </Checkbox>
                                                    <DescriptionWrapper {...styles.checkBoxDescWrapper}>
                                                        {translate(
                                                            "I want to receive future communications on product, promotions, events and other information. Please note we use this information in strict accordance with our.",
                                                        )}
                                                        &nbsp;
                                                        <Link href="/PrivacyPolicyPage" target="_blank">
                                                            {translate("privacy policy.")}
                                                        </Link>
                                                    </DescriptionWrapper>
                                                </CheckboxGroup>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.fieldsGridChildContainer}>
                                            <GridItem {...styles.firstGridItem}></GridItem>
                                            <GridItem {...styles.secondGridItem}>
                                                <CheckboxGroup>
                                                    <Checkbox
                                                        aria-describedby="setDefaultCustomer-description"
                                                        checked={formFields.termsAndConditions}
                                                        onChange={handleTermsAndConditionsChange}
                                                        {...(formFieldsError.termsAndConditions
                                                            ? styles.checkboxError
                                                            : styles.checkboxStyles)}
                                                    >
                                                        {translate("Terms & Conditions *")}
                                                    </Checkbox>
                                                    <DescriptionWrapper {...styles.checkBoxDescWrapper}>
                                                        {translate("I have read and agree to ADI's")}
                                                        &nbsp;
                                                        <Link href="/TermsAndConditionsPage" target="_blank">
                                                            {translate(" Terms & Conditions.")}
                                                        </Link>
                                                    </DescriptionWrapper>
                                                </CheckboxGroup>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer {...styles.recaptchaGridContainer}>
                                            <ReCaptcha recaptchaRef={recaptchaRef} location="ForgotPassword" />
                                        </GridContainer>
                                    </>
                                ) : null}
                                <GridContainer {...styles.submitGridContainer}>
                                    <GridItem {...styles.submitGridItem}>
                                        <Button
                                            {...styles.submitButton}
                                            // disabled={isSubmitRequested} // Added in P21 Change
                                            type="submit"
                                            data-test-selector="createAccount_createButton"
                                        >
                                            {isAuthenticated
                                                ? translate("Add a New User")
                                                : translate("Connect Existing Account")}
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridContainer>
                    </>
                )}
            </StyledForm>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(CreateAccount)),
    definition: {
        displayName: "Online Create Account",
        group: "Create Account",
        fieldDefinitions: [
            {
                name: fields.captchaIds,
                displayName: "Captcha Id",
                editorTemplate: "TextField",
                defaultValue: "reCaptcha1",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
